import React, { useState } from 'react';
import { Button } from 'shared/components/atoms/Button/Button';
import { Checkbox } from 'shared/components/molecules/Checkbox/Checkbox';
import { IconInput } from 'shared/components/molecules/IconInput/IconInput';
import api from 'services/api';

import mail from 'assets/icons/mail.svg';
import filled_mail from 'assets/icons/filled_mail.svg';
import { emailValidation } from 'utils/format';

import {
  Container,
  FieldsWrapper,
  LeftBottom,
  LeftCenter,
  LeftTop,
  RegisterWrapper,
  RepfyLogo,
  RightBottom,
  RightTop,
} from './_forgotPassword';
import { Modal } from 'shared/components/organisms/Modal/Modal';
import { toast } from 'react-toastify';
import { Spinner } from 'shared/components/atoms/Spinner/Spinner';
import { useHistory } from 'react-router';

interface IForgotPassword {
  confirmEmail: string;
  setConfirmEmail: Function;
}

export const ForgotPassword: React.FC<IForgotPassword> = () => {
  const history = useHistory();
  const [confirmEmail, setConfirmEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const [showModal, setShowModal] = useState<boolean>(false);
  const disabled = () => {
    if (!emailValidation(confirmEmail) || loading) {
      return true;
    }

    return false;
  };

  const handleForgotPassword = async () => {
    setLoading(true);

    const email = {
      email: confirmEmail,
    };
    try {
      await api.post(`password/forgot`, email);

      toast.success('Instruções enviadas! Verifique seu email');

      redirectToLogin();
    } catch (error: any) {
      handleError(error.response?.data?.message || error.toString());
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error: string) => {
    toast.error(error);
  };

  const redirectToLogin = () => {
    setTimeout(() => {
      history.push('login');
    }, 5000);
  };

  const handleGoBack = () => {
    history.push('login');
  }

  return (
    <Container>
      <LeftTop />

      <LeftCenter />

      <LeftBottom />

      <RegisterWrapper>
        <RepfyLogo />

        <h1>Prestadores</h1>

        <FieldsWrapper>
          <div className="fields-wrapper__info">
            <span className="fields-wrapper__info__title">Alterar senha</span>

            <p className="fields-wrapper__info__call">
              Por favor confirme seu email. <br /> As instruções serão enviadas
              para o seu e-mail.
            </p>
          </div>

          <div className="group__wrapper">
            <IconInput
              icon={mail}
              activeIcon={filled_mail}
              inputValue={confirmEmail}
              setInputValue={setConfirmEmail}
              placeholder={'Email'}
            />

            <Button
              disabled={disabled()}
              onClick={() => handleForgotPassword()}
            >
              {loading ? <Spinner /> : 'Confirmar'}
            </Button>

           {/*  <Button backgroundColor='#C42D2D' onClick={handleGoBack}>
              Voltar
            </Button> */}

          </div>
        </FieldsWrapper>
      </RegisterWrapper>

      <Modal showModal={showModal} setShowModal={setShowModal}></Modal>

      <RightTop />

      <RightBottom />
    </Container>
  );
};
